module.exports = __webpack_public_path__ + "static/img/stop.9c316f4a.svg";